import React from 'react';
import { HeroVariant43 } from '../components/HeroVariant43';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage43() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1657">
      {/* Navigation is intentionally omitted here because it is built into HeroVariant43 */}
      <main data-id="element-1658">
        <HeroVariant43 data-id="element-1659" />
        <WhyUs data-id="element-1660" />
        <Services data-id="element-1661" />
        <FAQ data-id="element-1662" />
        <Testimonials data-id="element-1663" />
        <Consultation data-id="element-1664" />
      </main>
      <Footer data-id="element-1665" />
      <CookieBanner data-id="element-1666" />
      <FloatingContact data-id="element-1667" />
    </div>;
}